import { makeStyles, tokens } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  card: {
    backgroundColor: designTokens.neutral.white,
    borderRadius: designTokens.borderRadius.lg,
    boxShadow: designTokens.shadow.base,
    padding: designTokens.spacing[5],
    flex: "0 0 280px",
    borderTop: `3px solid ${designTokens.accent[500]}`,
    minWidth: "280px",
    minHeight: "140px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },
  pendingBadge: {
    position: "absolute",
    top: designTokens.spacing[3],
    right: designTokens.spacing[3],
    fontSize: designTokens.fontSize.xxs,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[500],
    backgroundColor: designTokens.neutral[100],
    borderRadius: designTokens.borderRadius.full,
    padding: "2px 8px",
  },
  warningBadge: {
    position: "absolute",
    top: designTokens.spacing[3],
    right: designTokens.spacing[3],
    fontSize: designTokens.fontSize.xxs,
    fontWeight: designTokens.fontWeight.semibold,
    color: "#92400E",
    backgroundColor: "rgba(245,166,35,0.12)",
    borderRadius: designTokens.borderRadius.full,
    padding: "2px 8px",
  },
  label: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
    textTransform: "uppercase",
    fontSize: designTokens.fontSize.xxs,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.primary[700],
    letterSpacing: designTokens.letterSpacing.wide,
  },
  subtitle: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    marginTop: designTokens.spacing[1],
  },
  value: {
    fontSize: designTokens.fontSize["3xl"],
    fontWeight: designTokens.fontWeight.bold,
    color: designTokens.primary[800],
    marginTop: "auto",
    paddingTop: designTokens.spacing[4],
    paddingBottom: designTokens.spacing[2],
    lineHeight: String(designTokens.lineHeight.tight),
  },
  valuePending: {
    fontSize: designTokens.fontSize["3xl"],
    fontWeight: designTokens.fontWeight.bold,
    color: designTokens.neutral[300],
    marginTop: "auto",
    paddingTop: designTokens.spacing[4],
    paddingBottom: designTokens.spacing[2],
    lineHeight: String(designTokens.lineHeight.tight),
  },
  deltaBadge: {
    display: "inline-flex",
    alignItems: "center",
    alignSelf: "flex-start",
    padding: "2px 8px",
    borderRadius: designTokens.borderRadius.full,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    marginTop: designTokens.spacing[2],
  },
  deltaPositive: {
    backgroundColor: designTokens.semantic.successLight,
    color: designTokens.semantic.successDark,
  },
  deltaNegative: {
    backgroundColor: designTokens.semantic.errorLight,
    color: designTokens.semantic.error,
  },
  skeletonValue: {
    width: "60%",
    height: "40px",
    marginTop: designTokens.spacing[4],
    borderRadius: designTokens.borderRadius.md,
  },
  skeletonDelta: {
    width: "35%",
    height: "20px",
    marginTop: designTokens.spacing[2],
    borderRadius: designTokens.borderRadius.full,
  },
  unavailablePlaceholder: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    textAlign: "left",
    marginTop: "auto",
    minHeight: "72px",
    paddingTop: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[3],
    borderRadius: designTokens.borderRadius.md,
    color: designTokens.neutral[400],
    fontSize: designTokens.fontSize.xs,
    lineHeight: String(designTokens.lineHeight.normal),
    cursor: "default",
    ":focus-visible": {
      outline: `2px solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: "2px",
    },
  },
});
